import React from 'react'

import LayoutAuth from 'components/layouts/LayoutAuth'
import TemplateResetPassword from 'components/templates/TemplateResetPassword'
import {TPageComponent} from 'src/types'

interface IResetPasswordProps {}

const ResetPassword: TPageComponent<IResetPasswordProps> = () => {
	return <TemplateResetPassword />
}

ResetPassword.displayName = 'ResetPassword'

ResetPassword.Layout = LayoutAuth

export default ResetPassword
